export enum ScreenType {
  screen = <any>'screen',
  projector = <any>'projector'
}
